import { api } from "../utilites/api";
import { ErrorLog } from "../models/error-log-interface"

export const ErrorLogApi = {
  getErrorLogs: (date: string): Promise<ErrorLog[]> => api.get(`error/log?logsfordate=${date}`, '2.0'),
}